import { Api } from "../../Config/Request";
export const requestcontact = async (data) => {
    console.log(data);
    
//   return Api.PostRequest( 
//     "https://worx-assistant-function-app.azurewebsites.net/api/queryAssistantProxy",
//     data,
//     true
//   );
};

const ContactApiRequests = {
    requestcontact,
  };
  export default ContactApiRequests;